useGetRequest;

import { useEffect, useState } from "react";

const useGetRequest = (route) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        setError(null);

        const controller = new AbortController();

        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            signal: controller.signal
        };
        fetch(route, requestOptions)
            .then((response) => {
                return response.ok ? response.json() : Promise.reject(response);
            })
            .then((responseData) => {
                setData(responseData);
            })
            .catch((err) => {
                if (err.name !== "AbortError") {
                    setError(err);
                }
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [route]);

    return {
        data: data,
        error: error,
        loading: loading
    };
};

export default useGetRequest;
